export default __webpack_public_path__ + "static/media/HandIconImg.f0278421.webp";